import { getActiveCaisseYear, buildCaisseYearOptions, getCaisseStartYear } from './caisseActiveYear';

export const CGM_MONTH_OPTIONS = [
  { value: 1, label: 'Janvier' },
  { value: 2, label: 'Février' },
  { value: 3, label: 'Mars' },
  { value: 4, label: 'Avril' },
  { value: 5, label: 'Mai' },
  { value: 6, label: 'Juin' },
  { value: 7, label: 'Juillet' },
  { value: 8, label: 'Août' },
  { value: 9, label: 'Septembre' },
  { value: 10, label: 'Octobre' },
  { value: 11, label: 'Novembre' },
  { value: 12, label: 'Décembre' },
];

export function getCurrentMonthYear() {
  const now = new Date();
  return { month: now.getMonth() + 1, year: getActiveCaisseYear() };
}

export function extractMonthYearFromDate(dateStr) {
  if (!dateStr) return null;
  const str = String(dateStr).trim();
  const m = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) {
    return { year: parseInt(m[1], 10), month: parseInt(m[2], 10), day: parseInt(m[3], 10) };
  }
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return null;
  return { month: d.getMonth() + 1, year: d.getFullYear(), day: d.getDate() };
}

export function filterByMonthYear(items, month, year, dateGetter = (item) => item.date || item.created_at) {
  return (items || []).filter((item) => {
    const parts = extractMonthYearFromDate(dateGetter(item));
    if (!parts) return false;
    return parts.month === month && parts.year === year;
  });
}

/**
 * Options d'années : plage caisse (start → année calendaire)
 * + années présentes dans les données (historique).
 */
export function buildYearOptions(items, dateGetter = (item) => item.date || item.created_at) {
  const years = new Set(buildCaisseYearOptions());
  const start = getCaisseStartYear();
  for (const item of items || []) {
    const parts = extractMonthYearFromDate(dateGetter(item));
    if (parts && parts.year >= start) years.add(parts.year);
  }
  return [...years].sort((a, b) => b - a);
}

